import events from '@/services/data/calendar.js'
import { fakeFetch } from '@/services/fetchService.js'

class CalendarService {
  constructor() {
    this.type = 'mock'
  }

  async fetchCalendarEntries(startDate, endDate) {
    const eventData = events(startDate, endDate)
    return fakeFetch(eventData, 500) // wait 500ms before returning
  }
}

export default CalendarService
export const calendarService = new CalendarService()
